var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('demand-list', { attrs: { "readonly": false, "type": "submitted" } });
};
var staticRenderFns = [];

export { render, staticRenderFns };